import { AnimationEvent, EventHandler } from 'react'
import LazyImage from '@components/LazyImage'
import styles from './index.module.sass'

interface Props {
  iconUrl: string;
  text?: string;
  status: string;
  onAnimationEnd?: EventHandler<AnimationEvent> | undefined;
}

const NoticeBubble = ({ iconUrl, text, status, onAnimationEnd }: Props) => {
  return (
    <div className={styles.noticeBubble} onAnimationEnd={onAnimationEnd}>
      <div className={styles.image}>
        <LazyImage lazy={0} src={iconUrl} />
      </div>
      <div className={styles.info}>
        <span className={styles.text}>{text}</span>
        <span className={styles.status}>{status}</span>
      </div>
    </div>
  )
}

NoticeBubble.defaultProps = {
  text: '',
  onAnimationEnd: undefined
}

export default NoticeBubble
